import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withHuggg } from 'hoc';
import { compose } from 'redux';
import { getSegments } from 'redux/modules/huggg';
import { SegmentCarouselDisplay } from 'components/ui/SegmentCarouselDisplay';

export const SegmentCarousel = props => {
  const { huggg, segments, onSelectSegment, isVirginBrandProduct } = props;

  return (
    <SegmentCarouselDisplay
      huggg={huggg}
      segments={segments}
      onSelectSegment={onSelectSegment}
      isVirginBrandProduct={isVirginBrandProduct}
    />
  );
};

SegmentCarousel.propTypes = {
  huggg: PropTypes.object,
  segments: PropTypes.array,
  onSelectSegment: PropTypes.func,
  isVirginBrandProduct: PropTypes.bool
};

const mapStateToProps = state => {
  return {
    segments: getSegments(state)
  };
};

export default compose(withHuggg, connect(mapStateToProps))(SegmentCarousel);
